import * as _ from 'lodash'
import { IBusinessObject, IBusinessObjectCreateLoadOptions } from "../PA.Core/PA.Core.IF.BO";
import { IMessageProvider, IProgressProvider, MessageType } from "../PA.Core/PA.Core.IF.Basic";
import {PAdbContext} from '../PA.Core/PAdbContext';
import {IdentityProvider} from '../PA.Core/Basic/Identity'
import {MessageProvider} from '../PA.Core/Basic/Messages'
import {ProgressProvider} from '../PA.Core/Basic/Progress'

import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {BehaviorSubject} from "rxjs";
import {
    WB_SalesOrgRow,
    WB_EntityRow,
    WB_CustomerHierarchyRow,
    WB_ProductHierarchyRow,
    WB_PeriodHierarchyRow, WB_SimulationRow, WB_Published_ModelRow
} from "../PA.Core/PAdbSchemaRows";
import { ErrorMessage_restate, InfoMessage_restate } from "../PA.Core/Basic/MessageUtils";
import {
    esWB_Customer_Hierarchy,
    esWB_Entity, esWB_Period_Hierarchy, esWB_Product_Hierarchy,
    esWB_Published_Model,
    esWB_SalesOrg,
    esWB_Simulation
} from "../PA.Core/PAdbSchema";
import { TextUtils } from "../PA.Core/Basic/Text";

let wbIdSequenceVal = 77000000

export interface ISimulationCompareLoadOptions extends  IBusinessObjectCreateLoadOptions {
    wbSimulationIds?: number[]
}

export class SimulationCompareBO
    implements IBusinessObject
{
    Identity: IdentityProvider;

    CreateOptions: any;

    LoadOptions: ISimulationCompareLoadOptions;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;


    constructor(options?: any) {

        this.CreateOptions = options || {};

        if ('dbContext' in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext;

        this.Identity = new IdentityProvider({id: 0, name: 'New Simulation Compare'});

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = undefined;
        this.LoadProgressProvider = new ProgressProvider('Loading', this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);


        this.ISimulationCompare_init();
    }



    //<editor-fold desc = "IBusinessObject operations">

    async LoadNew(options?: ISimulationCompareLoadOptions): Promise<IBusinessObject> {
        const self = this;

        self.LoadProgressProvider.start("Creating Simulation Compare");
        let rv = self._OnLoadComplete = (async () => {

            self.LoadOptions = options || {};
            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if (_.isEmpty(self.dbContext)) {
                let sError = "Unable to determine dbContext for new Simulation Compare.";
                self._OnLoadComplete = undefined;
                self.LoadProgressProvider.exception(sError);

                return self;
            }
            try {
                // Create record using dbContext
                self.Identity.setAll(self.simulationCompareWbId, self.simulationCompareId, self.simulationCompareName);

                self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");

                await self._AfterBoLoadCompleteInternal()

                self.Identity.setAll(self.simulationCompareWbId, self.simulationCompareId, self.simulationCompareName);

                self._bIsLoaded = true;
                self._OnLoadComplete = undefined;
                self.LoadProgressProvider.finish();
                return self;
            } catch (err) {
                self.LoadProgressProvider.exception(err)
                return self
            }

        })();

        return rv;
    }

    async Load(anId: number | number, options?: object): Promise<IBusinessObject> {
        const self = this;

        throw "Load not Supported"

    }


    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }


    async Validate(options?: any): Promise<IBusinessObject> {
        const self = this;

        const mp = self.ValidateMessageProvider
        const pp  = self.ValidateProgressProvider
        mp.clearMessages();
        pp.start("Validating");
        self.ValidateOptions = options || {};
        const initMsgs = self.initMessageProvider.Messages
        mp.addMessages(initMsgs)
        ErrorMessage_restate(mp, _.isEmpty(self.salesOrg), 'SalesOrg', 'Unable to resolve SalesOrg')
        ErrorMessage_restate(mp, _.isEmpty(self.customerEntity), 'CustomerEntity', 'Unable to resolve Customer Entity')
        ErrorMessage_restate(mp, _.isEmpty(self.productEntity), 'ProductEntity', 'Unable to resolve Product Entity')
        ErrorMessage_restate(mp, _.isEmpty(self.periodEntity), 'PeriodEntity', 'Unable to resolve Period Entity')
        ErrorMessage_restate(mp, _.isEmpty(self.customerHierarchy), 'CustomerHierarchy', 'Unable to resolve Customer Hierarchy')
        ErrorMessage_restate(mp, _.isEmpty(self.productHierarchy), 'ProductHierarchy', 'Unable to resolve Product Hierarchy')
        ErrorMessage_restate(mp, _.isEmpty(self.periodHierarchy), 'PeriodHierarchy', 'Unable to resolve Period Hierarchy')

        if (mp.countMessages(MessageType.Error) > 0) {
            self._bIsValidated = false;
        } else {
            self._bIsValidated = true;
        }
        pp.finish()
        return self
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }


    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    async SaveUsing(bBatch: boolean, options?: any): Promise<IBusinessObject> {
        const self = this;

        self._bIsSaved = false
        throw "Save not Supported"
    }

    get bIsSaved(): boolean {
        return this._bIsSaved;
    }


//Delete
    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private async DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        const self = this;
        throw "Delete not Supported"

    }

    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }

    private async _AfterBoLoadCompleteInternal(): Promise<void> {
        const self = this;


        self.LoadProgressProvider.setProgressMessage('SimulationCompareBO.PostLoad', 'Processing Loaded Data');
        await self.ISimulationCompare_onLoadComplete()

        return
    }


    //</editor-fold>



    //<editor-fold desc = "ISimulationCompare operations">

    private simulationCompareWbId: number
    private simulationCompareId: string
    private simulationCompareName: string
    private initMessageProvider: MessageProvider
    private onSimulationScopeChanged: BehaviorSubject<SimulationCompareBO>
    private salesOrg: WB_SalesOrgRow
    private customerEntity: WB_EntityRow
    private productEntity: WB_EntityRow
    private periodEntity: WB_EntityRow
    private customerHierarchy: WB_CustomerHierarchyRow
    private productHierarchy: WB_ProductHierarchyRow
    private periodHierarchy: WB_PeriodHierarchyRow
    private wbSimulationIds: number[]
    private arrWbSimulationRows: WB_SimulationRow[]
    private arrWbPublishedModelRows: WB_Published_ModelRow[]

    private ISimulationCompare_init() {
        //--
        this.simulationCompareWbId = 0
        this.simulationCompareId = "NA"
        this.simulationCompareName = "AS"
        this.initMessageProvider = new MessageProvider()
        this.onSimulationScopeChanged = new BehaviorSubject<SimulationCompareBO>(this)
        this.salesOrg = undefined
        this.customerEntity = undefined
        this.productEntity = undefined
        this.periodEntity = undefined
        this.customerHierarchy = undefined
        this.productHierarchy = undefined
        this.periodEntity = undefined
        this.wbSimulationIds = []
        this.arrWbSimulationRows = []
        this.arrWbPublishedModelRows = []

    }

    private async ISimulationCompare_onLoadComplete(): Promise<void> {
        const self = this
        const opts = self.LoadOptions || {}
        const mp = self.initMessageProvider

        if(self.simulationCompareWbId == 0)
            self.simulationCompareWbId = wbIdSequenceVal++

        // This can initialize in two ways,
        // 1. A list of simulations,
        //  -- that will detect SalesOrg, Entity Levels, Hierarchies
        // 2. All the entity and hierarchy keys are provided in the loadOptions
        //  --

        // Validate will show any Errors
        let wbSalesOrgId = opts.wbSalesOrgId || 0
        let wbCustomerEntityId = opts.wbEntityIdCustomer || 0
        let wbProductEntityId = opts.wbEntityIdProduct || 0
        let wbPeriodEntityId = opts.wbEntityIdPeriod || 0
        let wbCustHId = opts.wbCustHId || 0
        let wbPrdHId = opts.wbPrdHId || 0
        let wbPeriodHId = opts.wbPeriodHId || 0
        let arrWbSimulationIds = opts.wbSimulationIds || []

        let wbSalesOrgRow: WB_SalesOrgRow = undefined
        let wbCustomerEntityRow: WB_EntityRow = undefined
        let wbProductEntityRow: WB_EntityRow = undefined
        let wbPeriodEntityRow: WB_EntityRow = undefined
        let wbCustomerHierarchyRow: WB_CustomerHierarchyRow = undefined
        let wbProductHierarchyRow: WB_ProductHierarchyRow = undefined
        let wbPeriodHierarchyRow: WB_PeriodHierarchyRow = undefined

        if(!_.isEmpty(arrWbSimulationIds)){
            self.arrWbSimulationRows = <WB_SimulationRow[]> await self.dbContext.findAll(esWB_Simulation, {where: {WB_SIMULATION_ID: {inq: arrWbSimulationIds}, DELETED_IND: {neq: '1'}}})
        }

        const dctPM: {[id: string]: number} = {}
        const dctSO: {[id: string]: number} = {}
        const dctEnt: {[id: string]: number} = {}
        const dctCustH: {[id: string]: number} = {}
        const dctPrdH: {[id: string]: number} = {}
        const dctPeriodH: {[id: string]: number} = {}
        if(wbSalesOrgId > 0)
            dctSO[wbSalesOrgId] = wbSalesOrgId
        if(wbCustomerEntityId > 0)
            dctEnt[wbCustomerEntityId] = wbCustomerEntityId
        if(wbProductEntityId > 0)
            dctEnt[wbProductEntityId] = wbProductEntityId
        if(wbPeriodEntityId > 0)
            dctEnt[wbPeriodEntityId] = wbPeriodEntityId
        if(wbCustHId > 0)
            dctCustH[wbCustHId] = wbCustHId
        if(wbPrdHId > 0)
            dctPrdH[wbPrdHId] = wbPrdHId
        if(wbPeriodHId > 0)
            dctPeriodH[wbPeriodHId] = wbPeriodHId

        _.forEach(self.arrWbSimulationRows, (a) => {
            if(a.cif.WB_PUBLISHED_MODEL_ID > 0)
                dctPM[a.cif.WB_PUBLISHED_MODEL_ID] = a.cif.WB_PUBLISHED_MODEL_ID
            if(a.cif.WB_SALESORG_ID > 0)
                dctSO[a.cif.WB_SALESORG_ID] = a.cif.WB_SALESORG_ID
            if(a.cif.WB_CUSTH_ID > 0)
                dctCustH[a.cif.WB_CUSTH_ID] = a.cif.WB_CUSTH_ID
            if(a.cif.WB_PRDH_ID > 0)
                dctPrdH[a.cif.WB_PRDH_ID] = a.cif.WB_PRDH_ID
            if(a.cif.WB_PERIODH_ID > 0)
                dctPeriodH[a.cif.WB_PERIODH_ID] = a.cif.WB_PERIODH_ID
        })
        if(!_.isEmpty(dctPM)) {
            self.arrWbPublishedModelRows = <WB_Published_ModelRow[]>await self.dbContext.findAll(esWB_Published_Model, { where: {WB_PUBLISHED_MODEL_ID: {inq: _.values(dctPM)}, DELETED_IND: {neq: '1'} } })
        }
        _.forEach(this.arrWbPublishedModelRows, (pm) => {
            _.forEach([pm.cif.WB_ENTITY_ID_CUSTOMER, pm.cif.WB_ENTITY_ID_PRODUCT, pm.cif.WB_ENTITY_ID_PERIOD], (wbId) => {
                if(wbId > 0)
                    dctEnt[wbId] = wbId
            })
        })
        let dctPublishedModels = _.keyBy(this.arrWbPublishedModelRows, (a) => a.cif.WB_PUBLISHED_MODEL_ID)


        let arrSalesOrgs: WB_SalesOrgRow[] = []
        if(!_.isEmpty(dctSO))
            arrSalesOrgs = <WB_SalesOrgRow[]> await self.dbContext.findAll(esWB_SalesOrg, {where: {WB_SALESORG_ID: {inq: _.values(dctSO)}}})

        let dctSalesOrg = _.keyBy(arrSalesOrgs,(a) => a.cif.WB_SALESORG_ID)


        let arrEntities: WB_EntityRow[] = []
        if(!_.isEmpty(dctEnt))
            arrEntities = <WB_EntityRow[]> await self.dbContext.findAll(esWB_Entity, {where: {WB_ENTITY_ID: {inq: _.values(dctEnt)}}})

        let dctEntities = _.keyBy(arrEntities, (a) => a.cif.WB_ENTITY_ID)
        let arrCustH: WB_CustomerHierarchyRow[] = []
        if(!_.isEmpty(dctCustH))
            arrCustH = <WB_CustomerHierarchyRow[]> await self.dbContext.findAll(esWB_Customer_Hierarchy, {where: {WB_CUSTH_ID: {inq: _.values(dctCustH)}}})
        let dctCustHiers = _.keyBy(arrCustH, (a) => a.cif.WB_CUSTH_ID)

        let arrPrdH: WB_ProductHierarchyRow[] = []
        if(!_.isEmpty(dctPrdH))
            arrPrdH = <WB_ProductHierarchyRow[]> await self.dbContext.findAll(esWB_Product_Hierarchy, {where: {WB_PRDH_ID: {inq: _.values(dctPrdH)}}})
        let dctPrdHiers = _.keyBy(arrPrdH, (a) => a.cif.WB_PRDH_ID)

        let arrPeriodH: WB_PeriodHierarchyRow[] = []
        if(!_.isEmpty(dctPeriodH))
            arrPeriodH = <WB_PeriodHierarchyRow[]> await self.dbContext.findAll(esWB_Period_Hierarchy, {where: {WB_PERIODH_ID: {inq: _.values(dctPeriodH)}}})
        let dctPeriodHiers = _.keyBy(arrPeriodH, (a) => a.cif.WB_PERIODH_ID)

        // Determine Comparable
        if(wbSalesOrgId > 0){
            wbSalesOrgRow = dctSalesOrg[wbSalesOrgId]
            ErrorMessage_restate(mp, _.isEmpty(wbSalesOrgRow), 'SOrgInvalid', `Init: Unable to resolve SalesOrg ${wbSalesOrgId}`)
        }

        if(wbCustomerEntityId > 0){
            wbCustomerEntityRow = dctEntities[wbCustomerEntityId]
            ErrorMessage_restate(mp, _.isEmpty(wbCustomerEntityRow), 'CEntInvalid', `Init: Unable to resolve Customer Entity ${wbCustomerEntityId}`)
        }
        if(wbProductEntityId > 0){
            wbProductEntityRow = dctEntities[wbProductEntityId]
            ErrorMessage_restate(mp, _.isEmpty(wbProductEntityRow), 'PrdEntInvalid', `Init: Unable to resolve Product Entity ${wbProductEntityId}`)
        }

        if(wbPeriodEntityId > 0) {
            wbPeriodEntityRow = dctEntities[wbPeriodEntityId]
            ErrorMessage_restate(mp, _.isEmpty(wbPeriodEntityRow), 'PeriodEntInvalid', `Init: Unable to resolve Period Entity ${wbPeriodEntityId}`)
        }


        if(wbCustHId > 0) {
            wbCustomerHierarchyRow = dctCustHiers[wbCustHId]
            ErrorMessage_restate(mp, _.isEmpty(wbCustomerHierarchyRow), 'CustHierInvalid', `Init: Unable to resolve Customer Hierarchy ${wbCustHId}`)
        }

        if(wbPrdHId > 0) {
            wbProductHierarchyRow = dctPrdHiers[wbPrdHId]
            ErrorMessage_restate(mp, _.isEmpty(wbCustomerHierarchyRow), 'PrdHierInvalid', `Init: Unable to resolve Product Hierarchy ${wbPrdHId}`)
        }
        if(wbPeriodHId > 0) {
            wbPeriodHierarchyRow = dctPeriodHiers[wbPeriodHId]
            ErrorMessage_restate(mp, _.isEmpty(wbPeriodHierarchyRow), 'PeriodHierInvalid', `Init: Unable to resolve Period Hierarchy ${wbPeriodHId}`)
        }

        let bHasMissingParts = _.isEmpty(wbSalesOrgRow) || _.isEmpty(wbCustomerEntityRow) || _.isEmpty(wbProductEntityRow) || _.isEmpty(wbPeriodEntityRow) ||
            _.isEmpty(wbCustomerHierarchyRow) || _.isEmpty(wbProductHierarchyRow) || _.isEmpty(wbPeriodHierarchyRow)

        let simsMissingParts: WB_SimulationRow[] = []
        let simMismatchedParts: WB_SimulationRow[] = []
        let simsToCheck: WB_SimulationRow[] = []
        if(bHasMissingParts){
            let bFoundGoodSim = false
            InfoMessage_restate(mp, true, 'MissingParts', `Using first of ${self.arrWbSimulationRows.length} Simulation(s) to resolve SalesOrg, Hierarchies and Entities`)

            _.forEach(self.arrWbSimulationRows, (sim) => {
                let s = sim.cif
                let pm = dctPublishedModels[s.WB_PUBLISHED_MODEL_ID]?.cif
                if(_.isEmpty(pm))
                    return

                let so = dctSalesOrg[s.WB_SALESORG_ID]
                let cstHr = dctCustHiers[s.WB_CUSTH_ID]
                let prdHr = dctPrdHiers[s.WB_PRDH_ID]
                let perdHr = dctPeriodHiers[s.WB_PERIODH_ID]

                let cstEnt = dctEntities[pm.WB_ENTITY_ID_CUSTOMER]
                let prdEnt = dctEntities[pm.WB_ENTITY_ID_PRODUCT]
                let perdEnt = dctEntities[pm.WB_ENTITY_ID_PERIOD]

                let bSimHasMissingParts = _.isEmpty(so) || _.isEmpty(cstHr) || _.isEmpty(prdHr) || _.isEmpty(perdHr) ||
                    _.isEmpty(cstEnt) || _.isEmpty(prdEnt) || _.isEmpty(perdEnt)

                if(bSimHasMissingParts)
                    simsMissingParts.push(sim)
                else {
                    simsToCheck.push(sim)
                    if(!bFoundGoodSim){
                        bFoundGoodSim = true
                        wbSalesOrgRow = so
                        wbCustomerHierarchyRow = cstHr
                        wbProductHierarchyRow = prdHr
                        wbPeriodHierarchyRow = perdHr
                        wbCustomerEntityRow = cstEnt
                        wbProductEntityRow = prdEnt
                        wbPeriodEntityRow = perdEnt
                    }
                }
            })

        } else {
            simsToCheck = _.clone(self.arrWbSimulationRows)
        }

        this.salesOrg = wbSalesOrgRow
        this.customerEntity = wbCustomerEntityRow
        this.productEntity = wbProductEntityRow
        this.periodEntity = wbPeriodEntityRow
        this.customerHierarchy = wbCustomerHierarchyRow
        this.productHierarchy = wbProductHierarchyRow
        this.periodHierarchy = wbPeriodHierarchyRow

        const bHasMissingParts_Pass2 = _.isEmpty(wbSalesOrgRow) || _.isEmpty(wbCustomerEntityRow) || _.isEmpty(wbProductEntityRow) || _.isEmpty(wbPeriodEntityRow) ||
            _.isEmpty(wbCustomerHierarchyRow) || _.isEmpty(wbProductHierarchyRow) || _.isEmpty(wbPeriodHierarchyRow)

        if(bHasMissingParts_Pass2){
            ErrorMessage_restate(mp, true, 'InitFailed', `Unable to resolve all required SalesOrg, Hierarchies and Entities`)
            return
        }

        this.simulationCompareId = TextUtils.padStart(this.simulationCompareWbId.toString(36), 12, '0').toUpperCase()
        this.simulationCompareName = `SalesOrg ${wbSalesOrgRow.cif.SALESORG_NAME} Compare (${this.simulationCompareId})`

        const comparableSims: WB_SimulationRow[] = []
        // Check if Simulations Keys Match, SalesOrg, discard errors
        _.forEach(simsToCheck, (sim) => {
            const s = sim.cif
            const pm = dctPublishedModels[s.WB_PUBLISHED_MODEL_ID]?.cif
            if(_.isEmpty(pm))
                return

            const so = dctSalesOrg[s.WB_SALESORG_ID]
            const cstHr = dctCustHiers[s.WB_CUSTH_ID]
            const prdHr = dctPrdHiers[s.WB_PRDH_ID]
            const perdHr = dctPeriodHiers[s.WB_PERIODH_ID]

            const cstEnt = dctEntities[pm.WB_ENTITY_ID_CUSTOMER]
            const prdEnt = dctEntities[pm.WB_ENTITY_ID_PRODUCT]
            const perdEnt = dctEntities[pm.WB_ENTITY_ID_PERIOD]

            const bSimHasMissingParts = _.isEmpty(so) || _.isEmpty(cstHr) || _.isEmpty(prdHr) || _.isEmpty(perdHr) ||
                _.isEmpty(cstEnt) || _.isEmpty(prdEnt) || _.isEmpty(perdEnt)
            if(bSimHasMissingParts) {
                simsMissingParts.push(sim)
                return
            }

            const bSimHasMismatchs = (so.cif.WB_SALESORG_ID != wbSalesOrgRow.cif.WB_SALESORG_ID) ||
                                   (cstHr.cif.WB_CUSTH_ID != wbCustomerHierarchyRow.cif.WB_CUSTH_ID) ||
                                   (prdHr.cif.WB_PRDH_ID != wbProductHierarchyRow.cif.WB_PRDH_ID) ||
                                   (perdHr.cif.WB_PERIODH_ID != wbPeriodHierarchyRow.cif.WB_PERIODH_ID) ||
                                   (cstEnt.cif.WB_ENTITY_ID != wbCustomerEntityRow.cif.WB_ENTITY_ID) ||
                                    (prdEnt.cif.WB_ENTITY_ID != wbProductEntityRow.cif.WB_ENTITY_ID) ||
                                    (perdEnt.cif.WB_ENTITY_ID != wbPeriodEntityRow.cif.WB_ENTITY_ID)
            if(bSimHasMismatchs){
                simMismatchedParts.push(sim)
            } else {
                comparableSims.push(sim)
            }

        }) // Next Sim To Check

        self.wbSimulationIds = _.map(comparableSims, (a) => a.cif.WB_SIMULATION_ID)

    }

    get SalesOrg(): WB_SalesOrgRow { return this.salesOrg }
    get CustomerEntity(): WB_EntityRow { return this.customerEntity }
    get ProductEntity(): WB_EntityRow { return this.productEntity }
    get PeriodEntity(): WB_EntityRow { return this.periodEntity }
    get CustomerHierarchy(): WB_CustomerHierarchyRow { return this.customerHierarchy }
    get ProductHierarchy(): WB_ProductHierarchyRow { return this.productHierarchy }
    get PeriodHierarchy(): WB_PeriodHierarchyRow { return this.periodHierarchy }
    get WbSimulationIds(): number[] { return this.wbSimulationIds }
    get OnSimulationScopeChanged(): BehaviorSubject<SimulationCompareBO> { return this.onSimulationScopeChanged }

    //</editor-fold>



};

PAEnvironment.registerBusinessObjectClass(SimulationCompareBO, "SimulationCompareBO", "Simulation Compare")
